export const PRIMARY_DELAY = 10000;
export const MAXIMUM_DELAY = 40000;
